import React from "react";
import {
    ETIQUETAS_TIPO_ALMACEN,
    agruparAlmacenesPorTipo,
} from "../helpers/almacenesReporte";
import {
    RenderKgSecos,
    RenderPorcentaje,
} from "./CeldasReporte";

// el total que llegó a bodega junta dos orígenes distintos, y cuando no cuadre
// va a ser lo primero que quieran revisar
const tituloDesgloseBodega = (fila) =>
    `Pacas recibidas en bodega: ${fila.kg_secos_bodega_pacas} kg | ` +
    `Sobrante enviado a bodega: ${fila.kg_secos_bodega_sobrante} kg`;

export const ResumenConsumoTable = ({ resumen, mensajeError }) => {
    if (mensajeError) {
        return (
            <div className="text-center py-5">
                <h3>{mensajeError}</h3>
            </div>
        );
    }

    if (!resumen) {
        return (
            <div className="text-center py-5">
                <h3>
                    Seleccione un rango de fechas y un producto padre para
                    generar el reporte
                </h3>
            </div>
        );
    }

    const almacenes = resumen.almacenes || [];

    if (!almacenes.length) {
        return (
            <div className="text-center py-5">
                <h3>
                    El producto padre seleccionado no tiene almacenes asociados
                </h3>
            </div>
        );
    }

    // sin ninguna semana completa la tabla solo tendría la fila de totales en
    // cero; el detalle de lo que falta sale en las advertencias del reporte
    if (!resumen.semanas.length) {
        return (
            <div className="text-center py-5">
                <h3>
                    Ninguna semana del rango cuenta con datos completos
                </h3>
            </div>
        );
    }

    const grupos = agruparAlmacenesPorTipo(almacenes);

    const renderCeldasFila = (fila) => (
        <React.Fragment>
            {almacenes.map((almacen) => (
                <td key={almacen.clave} className="text-right text-nowrap">
                    <RenderKgSecos value={fila.consumos[almacen.clave]} />
                </td>
            ))}

            <td className="text-right text-nowrap fw-bold cell-border-left">
                <RenderKgSecos value={fila.kg_secos_enviados_produccion} />
            </td>

            <td
                className="text-right text-nowrap cell-border-left"
                title={tituloDesgloseBodega(fila)}
            >
                <RenderKgSecos value={fila.kg_secos_bodega_total} />
            </td>
            <td className="text-right text-nowrap">
                <RenderKgSecos value={fila.kg_secos_miga} />
            </td>
            <td className="text-right text-nowrap fw-bold">
                <RenderKgSecos value={fila.kg_secos_obtenidos} />
            </td>

            <td className="text-right text-nowrap cell-border-left">
                <RenderKgSecos value={fila.diferencia_kg} />
            </td>
            <td className="text-right text-nowrap">
                <RenderPorcentaje value={fila.diferencia_porcentaje} />
            </td>
        </React.Fragment>
    );

    // filas de debajo de los totales con un valor por almacén; de los kg secos
    // enviados a producción en adelante van en blanco
    const renderFilaPorAlmacen = (etiqueta, valores, Celda) => (
        <tr className="resumen-consumo__porcentajes-row">
            <td className="text-nowrap cell-border-right">{etiqueta}</td>

            {almacenes.map((almacen) => (
                <td key={almacen.clave} className="text-right text-nowrap">
                    <Celda value={valores[almacen.clave]} />
                </td>
            ))}

            <td colSpan={6} className="cell-border-left" />
        </tr>
    );

    return (
        <div className="new-table-wrapper my-4 sticky-header sticky-first-column">
            <table className="table-striped-v2">
                {/* ================= HEADER ================= */}
                <thead>
                    <tr>
                        <th
                            rowSpan={2}
                            className="align-middle cell-border-right"
                        >
                            Semana
                        </th>

                        {grupos.map((grupo) => (
                            <th
                                key={grupo.tipo}
                                colSpan={grupo.columnas}
                                className="text-center resumen-consumo__grupo-header cell-border"
                            >
                                {ETIQUETAS_TIPO_ALMACEN[grupo.tipo]}
                            </th>
                        ))}

                        <th
                            rowSpan={2}
                            className="align-middle cell-border-left"
                        >
                            Kg secos enviados a producción
                        </th>

                        <th
                            rowSpan={2}
                            className="align-middle cell-border-left"
                        >
                            Kg secos producidos
                        </th>
                        <th
                            rowSpan={2}
                            className="align-middle"
                            style={{ minWidth: "100px" }}
                        >
                            Kg miga por semana
                        </th>
                        <th rowSpan={2} className="align-middle">
                            Total Kg secos obtenidos
                        </th>

                        <th
                            rowSpan={2}
                            className="align-middle cell-border-left"
                        >
                            Diferencia
                        </th>
                        <th rowSpan={2} className="align-middle text-nowrap">
                            % diferencia
                        </th>
                    </tr>
                    <tr>
                        {almacenes.map((almacen) => (
                            <th key={almacen.clave} className="text-nowrap">
                                {almacen.nombre}
                            </th>
                        ))}
                    </tr>
                </thead>

                {/* ================= BODY ================= */}
                <tbody>
                    {resumen.semanas.map((fila) => (
                        <tr key={`${fila.anio}-${fila.semana}`}>
                            <td className="text-nowrap cell-border-right">
                                <div className="d-flex flex-column">
                                    <span>{fila.etiqueta}</span>
                                    <span className="resumen-consumo__semana-rango">
                                        {fila.rango}
                                    </span>
                                </div>
                            </td>

                            {renderCeldasFila(fila)}
                        </tr>
                    ))}

                    {/* ===== TOTALES ===== */}
                    <tr className="totales-row">
                        <td className="text-nowrap fw-bold cell-border-right">
                            Totales
                        </td>

                        {renderCeldasFila(resumen.totales)}
                    </tr>

                    {/* ===== FILAS POR ALMACÉN ===== */}
                    {renderFilaPorAlmacen(
                        "% de aportes por almacén",
                        resumen.porcentajes,
                        RenderPorcentaje
                    )}
                    {renderFilaPorAlmacen(
                        "Producción atribuida por almacén",
                        resumen.produccion_atribuida,
                        RenderKgSecos
                    )}
                    {renderFilaPorAlmacen(
                        "Diferencia por almacén",
                        resumen.diferencia_por_almacen,
                        RenderKgSecos
                    )}
                    {renderFilaPorAlmacen(
                        "% de diferencia",
                        resumen.diferencia_porcentaje_por_almacen,
                        RenderPorcentaje
                    )}
                </tbody>
            </table>
        </div>
    );
};
